import { FormField, Input } from "@repo/skapa";
import { useState } from "react";

import { useSetDebounceValue } from "../hooks/useSetDebounceValue";

interface NumberFieldProps {
  id: string;
  label?: string;
  autoFocus?: boolean;
  editable?: boolean;
  value?: string;
  onChange?: (newValue?: string) => void;
  prefix?: string;
  min?: number;
  max?: number;
}
export const NumberField = ({
  id,
  label,
  autoFocus,
  editable,
  value,
  onChange,
  prefix,
  min,
  max,
}: NumberFieldProps) => {
  const saveValue = (newValue?: string) => {
    if (Number(value) !== Number(newValue)) {
      onChange?.(newValue);
    }
  };
  const [numberValue, setNumberValue] = useState(value?.replace(",", "."));
  const { setValueDebounced, clearDebounce } = useSetDebounceValue(
    saveValue,
    2500
  );

  return (
    <FormField>
      <Input
        aria-label={id}
        id={id}
        label={label}
        autoFocus={autoFocus}
        type="number"
        disabled={editable === false}
        value={numberValue ?? ""}
        onChange={(e) => {
          const targetValueNumber = Number(e.target.value);

          if (e.target.value === "" || !isNaN(targetValueNumber)) {
            setNumberValue(e.target.value);
            setValueDebounced(e.target.value);
          }
        }}
        onBlur={() => {
          clearDebounce();
          saveValue(numberValue);
        }}
        prefixLabel={prefix}
        min={min}
        max={max}
      />
    </FormField>
  );
};
